
export * from '../../frontend-js-react-web/__liferay__/exports/react-dnd-html5-backend.js';
